import { hasAdminModule, type AdminModuleName } from '@/utils/adminModules';

/**
 * Primary check: ADMIN with Employees module access.
 * Empty/missing modules on ADMIN keep the existing Employees tab (legacy).
 * Temporary fallback: VITE_EMPLOYEE_ADMIN_EMAILS allowlist.
 */
export function getEmployeeAdminEmails(): string[] {
  return (import.meta.env.VITE_EMPLOYEE_ADMIN_EMAILS ?? '')
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
}

export function isEmployeeAdmin(
  roleOrEmail?: string | null,
  email?: string | null,
  modules?: AdminModuleName[] | null,
): boolean {
  if (hasAdminModule(roleOrEmail === 'ADMIN' ? 'ADMIN' : undefined, modules, 'EMPLOYEES')) {
    return true;
  }

  const candidateEmail = (email ?? roleOrEmail)?.trim().toLowerCase();
  if (!candidateEmail || !candidateEmail.includes('@')) return false;
  return getEmployeeAdminEmails().includes(candidateEmail);
}
